
import { getSuluPage, fillSeo, getSuluApi, handleResponse} from 'razlet-sulu-sdk/lib/utils/helpers';
import Sulu from 'razlet-sulu-sdk/lib/entities/factory';

export default {
  name: 'index-page',
  layout: 'index',
  async asyncData ({ store, route, error, redirect}) {
    const results = await Promise.allSettled([
      getSuluPage({ store, route, error, redirect }),
      getSuluApi({ store, error, redirect, path: `news-list` }),
    ]);

    const [result, news] = handleResponse(results, error);
    return {result, news};
  },
  data() {
    return {
      news: {},
      result: {},
      loading: true,
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        if (process.client && query && Object.prototype.hasOwnProperty.call(query, 'flightSearch')) {
          const { href } = this.$router.resolve({ path: '/', query: { ...query } });
          this.redirectFlightSearch(href);
        }
      },
    },
  },
  created() {
    if (process.client) {
      this.watchFlightSearchHistory();
    }
    this.fillSulu(this.result, this.news);
  },
  mounted() {
    this.$bus.$on('locale-changed', () => {
      this.loading = true;
      window.scrollTo(0, 0);
      this.$nuxt.refresh().then(() => {
        this.fillSulu(this.result, this.news);
      });
    });
    if (!this._flightSearchRedirecting) {
      this.checkAffPath();
    }
  },
  beforeDestroy() {
    if (this._stopFlightSearchHistory) {
      this._stopFlightSearchHistory();
    }
  },
  destroyed() {
    this.$bus.$off('locale-changed');
  },
  methods: {
    redirectFlightSearch(href) {
      const url = new URL(href, window.location.origin);
      if (this._flightSearchRedirecting || window.location.pathname === '/sale' || !url.searchParams.has('flightSearch')) {
        return;
      }
      this._flightSearchRedirecting = true;
      window.location.assign(`/sale${url.search}`);
    },
    watchFlightSearchHistory() {
      let active = true;
      const checkQuery = () => {
        if (active) {
          this.redirectFlightSearch(window.location.href);
        }
      };
      const originals = {};
      const wrappers = {};
      ['pushState', 'replaceState'].forEach((method) => {
        originals[method] = window.history[method];
        wrappers[method] = function (...args) {
          const result = originals[method].apply(this, args);
          checkQuery();
          return result;
        };
        window.history[method] = wrappers[method];
      });
      window.addEventListener('popstate', checkQuery);
      this._stopFlightSearchHistory = () => {
        active = false;
        window.removeEventListener('popstate', checkQuery);
        Object.keys(originals).forEach((method) => {
          if (window.history[method] === wrappers[method]) {
            window.history[method] = originals[method];
          }
        });
      };
      checkQuery();
    },
    checkAffPath() {
      const affPath = window.location.hash;

      if (affPath && affPath.length > 3) {
        const route = affPath.substring(2, affPath.length);
        this.goToAffSeparatePage(route);
      }
    },
    goToAffSeparatePage(route) {
      window.location.href = `${window.location.origin}/sale#/${route}`;
    },
    fillSulu(res, news) {
      const suluFactory = new Sulu();
      this.result = suluFactory.create(res);
      this.news = suluFactory.create(news);
      this.loading = false;
    },
  },
  head() {
    return {
      ...fillSeo(this, this.result.seo),
    };
  },
};
